export default __webpack_public_path__ + "static/media/gallery_00.b3182024.jpg";